class BlogFilterList extends HTMLElement {
  connectedCallback() {
    if (this._wired) return;
    this._wired = true;
    this.sectionId = this.dataset.sectionId;
    this._onClick = this.onClick.bind(this);
    this._onPopState = this.onPopState.bind(this);
    this.addEventListener('click', this._onClick);
    window.addEventListener('popstate', this._onPopState);
  }

  disconnectedCallback() {
    if (this._onPopState) {
      window.removeEventListener('popstate', this._onPopState);
    }
  }

  onClick(event) {
    if (event.defaultPrevented) return;
    if (
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      event.button !== 0
    ) {
      return;
    }
    const link = event.target.closest('a.blog-tag-list');
    if (!link || link.target === '_blank') return;
    let url;
    try {
      url = new URL(link.href, window.location.origin);
    } catch (err) {
      return;
    }
    if (url.origin !== window.location.origin) return;
    event.preventDefault();
    this.navigate(url.toString());
  }

  onPopState() {
    this.fetchAndSwap(window.location.href);
  }

  navigate(url) {
    if (url === window.location.href) return;
    history.pushState({}, '', url);
    this.fetchAndSwap(url);
  }

  fetchAndSwap(url) {
    const fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set('section_id', this.sectionId);
    this.setAttribute('aria-busy', 'true');
    this.classList.add('is-loading');

    fetch(fetchUrl.toString())
      .then((response) => {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector(
          'blog-filter-list[data-section-id="' +
            CSS.escape(this.sectionId) +
            '"]'
        );
        if (!fresh) {
          window.location.href = url;
          return;
        }
        this.innerHTML = fresh.innerHTML;
        this.disableEntryAnimations();
        this.promoteLazyImages();
      })
      .catch(() => {
        window.location.href = url;
      })
      .finally(() => {
        this.removeAttribute('aria-busy');
        this.classList.remove('is-loading');
      });
  }

  disableEntryAnimations() {
    this.querySelectorAll('motion-effect').forEach((node) => {
      node.removeAttribute('data-animate');
      node.style.opacity = '1';
      node.style.transform = 'none';
    });
  }

  promoteLazyImages() {
    this.querySelectorAll('img.image-lazy-load').forEach((img) => {
      const picture = img.closest('picture');
      if (picture) {
        picture.querySelectorAll('source[data-srcset]').forEach((source) => {
          source.setAttribute('srcset', source.dataset.srcset);
          source.removeAttribute('data-srcset');
        });
      }
      if (img.dataset.srcset) {
        img.setAttribute('srcset', img.dataset.srcset);
        img.removeAttribute('data-srcset');
      }
      img.classList.remove('image-lazy-load');
      img.classList.add('lazy-loaded');
    });
  }
}

if (!customElements.get('blog-filter-list')) {
  customElements.define('blog-filter-list', BlogFilterList);
}
